import { render, staticRenderFns } from "./ai-customer-material.vue?vue&type=template&id=22afa462&"
import script from "./ai-customer-material.vue?vue&type=script&lang=js&"
export * from "./ai-customer-material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports